<div class="container px-0 px-md-3 " role="contentinfo">
    <div class="row no-gutters">
        <div class="col-12 d-flex justify-content-md-end col-12 d-flex justify-content-md-end
 flex-column flex-md-row" role="list">
            <span class="font_size-14 px-2 mb-4 mb-md-0" role="listitem">
                <a [href]="privacyandsecurityLink" target="_blank"
                    class="footer_white_col note_link">{{'footer.privacyandsecurity'|translate}}
                    <span class="show-for-sr">{{ 'footer.privacyPolicy' | translate }}</span></a>
            </span>
            <span class="font_size-14  px-2 mb-4 mb-md-0" role="listitem">
                <a [href]="legalLink" target="_blank" class="footer_white_col note_link">{{'footer.legal'|translate}}
                    <span class="show-for-sr">{{ 'footer.privacyPolicy' | translate }}</span></a>
            </span>
            <span class="font_size-14 px-2 mb-4 mb-md-0" role="listitem">
                <a [href]="accessibilityLink" id="accessibilityLink" target="_blank"
                    class="footer_white_col note_link">{{'footer.accessibility'|translate}}
                    <span class="show-for-sr">{{ 'footer.privacyPolicy' | translate }}</span></a>
            </span>
            <span class="font_size-14  px-2 mb-4 mb-md-0" role="listitem">
                <a [href]="cookiePolicyLink" target="_blank" class="footer_white_col note_link"
                    id="cookiePolicyLink">{{'footer.digitalPrefrencePolicy' | translate}}
                    <span class="show-for-sr">{{ 'footer.privacyPolicy' | translate }}</span>
                </a>
            </span>
            <span class="font_size-14  px-2 mb-4 mb-md-0" role="listitem">
                <a tabindex="0" target="_blank" onclick="OneTrust.ToggleInfoDisplay()"
                    class="footer_white_col note_link" id="manageCookieLink">{{'footer.manageCookiePreferences' |
                    translate}}
                    <span class="show-for-sr">{{ 'footer.manageCookiePrivacyPolicy' | translate
                        }}</span>
                </a>
            </span>
        </div>
    </div>
    <div class="row no-gutters mt-4">
        <div class="col-12 text-center text-md-left d-flex d-md-block flex-md-row flex-column">
            <div class="d-md-none mb-3 borderline"></div>
            <img class="logoImg-height font_size-14 mb-3 mb-md-0" src="../../../assets/icons/NewIcons/CIBC_logo_footer_Small.svg"
                alt="CIBC footer logo">
            <span class="font_size-14">{{'footer.canadianimperial' | translate}}</span>
        </div>
    </div>
</div>